// removed by extract-text-webpack-plugin
module.exports = {"review-mode":"_2ODW1t0mlq9-3D4OzIK2EV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/TextQuestion/TextQuestion.css
// module id = 784
// module chunks = 0